import { SimNaoEnum } from 'components/form'

import { isAllFilled, isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta14Model,
  ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum,
} from './model-consultaSeguimentoPergunta14'

const consultaSeguimentoPergunta14OlhaSeusOlhosEnumValues = Object.values(ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum)

export function isPergunta14OlhaSeusOlhosAllFilled(
  value: ConsultaSeguimentoPergunta14Model['PERGUNTA_14_OLHA_SEUS_OLHOS']
): boolean {
  return isAllFilled(value, consultaSeguimentoPergunta14OlhaSeusOlhosEnumValues)
}

export function hasPergunta14OlhaSeusOlhosAtLeastTwoSim(
  value: ConsultaSeguimentoPergunta14Model['PERGUNTA_14_OLHA_SEUS_OLHOS']
): boolean {
  return Object.values(value ?? {}).filter((item) => item === SimNaoEnum.SIM).length >= 2
}

export const isPergunta14OlhaSeusOlhosAllNao = (
  value: ConsultaSeguimentoPergunta14Model['PERGUNTA_14_OLHA_SEUS_OLHOS']
): boolean => {
  return isAllNao(value, consultaSeguimentoPergunta14OlhaSeusOlhosEnumValues)
}
